import { connect, ConnectedProps } from "react-redux";
import { withRouter } from "react-router";
import { CallState, Funnel } from "redmond";
import { PaymentCard } from "./component";
import {
  verifyPaymentMethod,
  listPaymentMethods,
  deletePaymentMethod,
  setSelectedPaymentMethodId,
  fetchProductToEarn,
  fetchAllEarnForProduct,
} from "../../actions/actions";
import {
  getDeletePaymentMethodCallState,
  getListPaymentMethodsCallState,
  getPaymentMethods,
  getVerifyPaymentMethodCallState,
  getSelectedPaymentMethodId,
  getTotalCreditCardPaymentRequired,
  getIsCreditCardPaymentRequired,
  getRewardsPaymentAccountReferenceId,
  getHasError,
  getRewardsPaymentAccount,
  getIsStackedTravelWalletPaymentOnly,
  getIsTravelWalletCreditPaymentOnly,
  getIsTravelWalletOfferPaymentOnly,
  getOffers,
  getOfferToApply,
  getEarnByRewardsAccountId,
  getTotalCreditCardPaymentRequiredInFiatPrice,
  getApplicableCredit,
  getFetchApplicableTravelWalletItemsCallState,
} from "../../reducer";
import {
  getAllowRewardsWithPolicy,
  getRewardsAccounts,
  getUserIsPrimaryCardHolder,
} from "../../../rewards/reducer";
import { fetchRewardsAccounts } from "../../../rewards/actions/actions";
import { getAllTravelWalletOffers } from "../../../travel-wallet/reducer";
import { IStoreState } from "../../../../reducers/types";
import { getConfigTenant, isCorpTenant, hasIneligibleTravelOffer } from "@capone/common";

const mapStateToProps = (state: IStoreState) => {
  const applicableOffers = getOffers(state);
  const allWalletOffers = getAllTravelWalletOffers(state);
  const hasIneligibleFTB =
    isCorpTenant(getConfigTenant()) &&
    hasIneligibleTravelOffer(allWalletOffers, applicableOffers ?? [], Funnel.Ground);

  const hasOffersOrCredts =
    (applicableOffers && applicableOffers.length > 0) ||
    Boolean(getApplicableCredit(state)) ||
    hasIneligibleFTB;

  return {
    paymentMethods: getPaymentMethods(state),
    rewardsAccounts: getRewardsAccounts(state),
    listPaymentMethodCallState: getListPaymentMethodsCallState(state),
    verifyPaymentMethodCallState: getVerifyPaymentMethodCallState(state),
    deletePaymentMethodCallState: getDeletePaymentMethodCallState(state),
    selectedPaymentMethodId: getSelectedPaymentMethodId(state),
    selectedRewardsPaymentAccount: getRewardsPaymentAccount(state),
    selectedRewardsPaymentAccountId: getRewardsPaymentAccountReferenceId(state),
    isCreditCardPaymentRequired: getIsCreditCardPaymentRequired(state),
    totalCreditCardPaymentRequired: getTotalCreditCardPaymentRequired(state),
    hasError: getHasError(state),
    isStackedTravelWalletPaymentOnly:
      getIsStackedTravelWalletPaymentOnly(state),
    isTravelCreditPaymentOnly: getIsTravelWalletCreditPaymentOnly(state),
    isTravelWalletOfferPaymentOnly: getIsTravelWalletOfferPaymentOnly(state),
    canRedeemRewards: getAllowRewardsWithPolicy(state),
    userIsPrimary: getUserIsPrimaryCardHolder(state),
    canUseTravelWallet: hasOffersOrCredts,
    offerToApply: getOfferToApply(state),
    earnByRewardsAccountId: getEarnByRewardsAccountId(state),
    totalCardPaymentRequired:
      getTotalCreditCardPaymentRequiredInFiatPrice(state),
    credits: getApplicableCredit(state),
    filteredOffers: getOffers(state),
    walletLoaded:
      getFetchApplicableTravelWalletItemsCallState(state) === CallState.Success,
  };
};

const mapDispatchToProps = {
  verifyPaymentMethod,
  listPaymentMethods,
  deletePaymentMethod,
  setSelectedPaymentMethodId,
  fetchRewardsAccounts,
  fetchProductToEarn,
  fetchAllEarnForProduct,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type PaymentCardConnectorProps = ConnectedProps<typeof connector>;

export const ConnectedPaymentCard = withRouter(connector(PaymentCard));
